// MODULES
import { NFTI } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import { useAllLots } from 'src/features/common/collectible/hooks/collectible.hooks';
import { TransferNftModal } from 'src/features/common/collectible/modals/transfer-nft-modal';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
// RESOURCES
import { Button } from 'src/ui/common/atoms/button';
import { useGetActiveTokenTransaction } from '../../hooks/useGetActiveTokenTransaction.hook';
import { useActionWithAuthorization } from './actions.hooks';

interface MintCollectibleButtonI {
    nft: NFTI;
}

export const TransferNftAction = ({ nft }: MintCollectibleButtonI) => {
    const { t } = useTranslation(['actions']);
    const allLots = useAllLots();
    const { isNinjaTemplate, isOceanTemplate } = useGetUniverseTemplate();

    const activeTransactions = useGetActiveTokenTransaction();

    const transfer = useCallback(async () => {
        TransferNftModal.open({ nft, lot: allLots[0] });
    }, [allLots, nft]);

    const transferWithAuthorization = useActionWithAuthorization({
        callback: transfer,
    });

    const getButtonVariant = useCallback(() => {
        if (isNinjaTemplate) {
            return 'whiteRounded';
        }
        if (isOceanTemplate) {
            return 'o_white';
        }
        return 'white';
    }, [isNinjaTemplate, isOceanTemplate]);

    return (
        <>
            <Button
                onClick={transferWithAuthorization}
                disabled={!!activeTransactions[0]}
                data-test-id="transfer-ownership-btn"
                variant={getButtonVariant()}
                size="lg"
            >
                {t('trade.transferNFT')}
            </Button>
        </>
    );
};
